// extracted by mini-css-extract-plugin
export default {"link":"VP-z","disabled":"WP-z"};